import Modal from "react-modal";
import styled from 'styled-components'
import { injectIntl } from 'react-intl'

const style = {
  overlay: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 5,
    backgroundColor: 'rgba(255, 255, 255, 0.75)'
  },
  content: {
    position: 'static',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0px 0px 30px 4px rgba(0,0,0,0.10)',
    background: '#fff',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '4px',
    outline: 'none',
    padding: '0px',
    width: '700px',
    marginLeft: '10px',
    marginRight: '10px'
  }
}


const HeadingWrapper = styled.div`
  background: ${p => p.theme.colors[p.color]};
  color: ${p => p.theme.colors.on[p.color]};
  width:100%;
  display:flex;
  align-items:center;
  justify-content:center;
  padding:15px;
`

const Heading = styled.h2`
  margin: 0;
  text-transform: uppercase;
`

const P = styled.div`
  padding: 40px 20px;
  text-align: center;
`

const IconWrapper = styled.div`
  display:flex;
  justify-content:space-around;
  padding-bottom:20px;
  width:150px;
`

const Icon = styled.em`
  font-size:28px;
  cursor:pointer;

  &:hover {
      opacity: 0.5;
      
  }
  
`

const ButtonsWrapper = styled.div`
  padding: 0 15px 15px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ConfirmBtn = styled.button`
  margin: 0 10px;
  background:    ${p => p.theme.colors[p.color]};
  border-radius: 50px;
  border:none;
  padding:       15px 25px;
  color:         ${p => p.theme.colors.on[p.color]};
  display:       inline-block;
  text-align:    center;
  font-weight:bold;
`


const _Modal = injectIntl(({ intl, text, heading, confirm, type = 'danger' }) => {
  return (
    <Modal
      isOpen={true}
      style={style}
      aria={{
        labelledby: "heading",
        describedby: "full_description"
      }}

    >
      <HeadingWrapper color={type}>
        <Heading>{intl.formatMessage({ id: heading })}</Heading>
      </HeadingWrapper>

      <P>{text}</P>
      {/*
        !confirm && (
          <IconWrapper>
            <Icon className="fal fa-redo" onClick={() => location.reload()} />
            <Icon className="fal fa-arrow-left" onClick={() => window.history.back()} />
          </IconWrapper>
        )
      */}
      <ButtonsWrapper>
        {
          confirm && <ConfirmBtn onClick={confirm}>{intl.formatMessage({ id: 'Confirm' })}</ConfirmBtn>
        }
        <ConfirmBtn onClick={() => location.reload()} color={type}>{intl.formatMessage({ id: 'Close' })}</ConfirmBtn>
      </ButtonsWrapper>
    </Modal>
  )
})

export default _Modal